<template>
	<div>
		<titles titlename="1X任务考核详情" titlecontent="1X任务考核详情" :mbx="paths"></titles>
		<div class="taskxqtitle">1X考核试卷报名与考试详情</div>
		<div class="taskxqtitletopcontent">
			<div class="taskxqtitletopleft">
				<img src="@/assets/taskxq.svg" alt="" />
				<div class="taskxqbotmbox">
					<p class="taskxqbotmboxtitle">{{jxpaperobj.ExamName ?? ''}}</p>
					<div class="taskxqbotmboxusers">
						<span class="icons el-icon-s-custom"></span>
						<span class="tasktitle">报名人数</span>
						<span style="margin-left: 40px;color: red;">{{jxpaperobj.Enrollment ?? ''}}</span>
					</div>
					<div class="taskxqbotmboxusers">
						<p>
							<span class="icons el-icon-time"></span>
							<span class="tasktitle">报名截止时间</span>
						</p>
						<span style="color: #333;">{{jxpaperobj.Deadlinedate ?? ''}}</span>
					</div>
					<div class="taskxqbotmboxusers">
						<p>
							<span class="icons el-icon-time"></span>
							<span class="tasktitle">考试时间</span>
						</p>
						<span style="color: #333;">{{jxpaperobj.Examdate ?? ''}}</span>
					</div>
				</div>
			</div>
			
			<div class="taskxqtitletopright">
				<el-table :data="list" style="width: 100%">
					<el-table-column prop="ui_realName" label="学生姓名"></el-table-column>
					<el-table-column prop="registrationtime" label="报名时间"></el-table-column>
					<el-table-column prop="address" label="考试状态">
						<template slot-scope="scope">
							<el-tag type="warning" effect="dark" v-if="scope.row.Examstatus == 0">未考试</el-tag>
							<el-tag type="success" effect="dark" v-if="scope.row.Examstatus == 1">已考试</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="Examtime" label="考试时间">
						<template slot-scope="scope">
							<div>{{scope.row.Examtime ?? '暂未考试'}}</div>
							</template>
					</el-table-column>
					<!-- <el-table-column label="操作">
						<template slot-scope="scope" >
							<el-button v-if="scope.row.Examstatus == 1" @click="handleClick(scope.row)" type="text" size="small">查看试卷</el-button>
							<div v-else>暂未考试</div>
						</template>
					</el-table-column> -->
				</el-table>
				<div class="elpaginations" v-if="allnums > list.length">
					<el-pagination
						@current-change="handleCurrentChange"
						:current-page.sync="currentPage1"
						:page-size="pagesize"
						layout="total, prev, pager, next"
						:total="allnums"
					></el-pagination>
				</div>
			</div>
		</div>
		<div class="taskxqbotmtitle">考核动态</div>
		<div class="trendsboxs"><steps></steps></div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import steps from './components/steps.vue';
import { 
	GetJxPaperDetail
} from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	data() {
		return {
			currentPage1: 1,
			pagesize:10,
			allnums:0,
			list:[],
			// 标题组件
			paths: [
				{
					path: '/assessmenttask/Assessmenttaskxq',
					name: '任务考核详情'
				}
			],
			editableTabsValue: '1',
			editableTabs: [
				{
					title: '班级1',
					name: '1',
					content: '班级12'
				},
				{
					title: '班级2',
					name: '2',
					content: '班级13231232'
				}
			],
			tableData: [
				{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				},
				{
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				},
				{
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}
			],
			isids: '',
			jxpaperobj:{}
		};
	},
	mounted() {
		if (this.$route.query) {
			this.isids = this.$route.query.id ?? '';
			this.init()
		}else{
			this.$router.back()
		}
	},
	components: {
		titles,
		steps
	},
	methods: {
		init(){
			this.getlistJxPaper()
		},
		getlistJxPaper(){
			let dataobj = {
				JX_GUID:this.isids,
				pageIndex:this.currentPage1,
				pageSize:this.pagesize
			}
			GetJxPaperDetail(dataobj).then(res=>{
				this.list = res.data.data.list.JxApplications
				this.jxpaperobj = res.data.data.list
				this.allnums = res.data.data.totalCount
			})
		},
		
		handleClick() {
			console.log('查看试卷');
		},
		handleCurrentChange(val) {
			this.currentPage1 = val;
		}
	}
};
</script>

<style scoped lang="less">
.elpaginations {
	height: 80px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.trendsboxs {
	height: 400px;
	background-color: #fff;
	border-radius: 4px;
	overflow-y: scroll;
	padding-top: 20px;
	padding-bottom: 20px;
	padding-left: 40px;

	&::-webkit-scrollbar {
		display: none;
	}
}

.taskxqbotmtitle {
	width: 100%;
	padding: 10px 0;
	background-color: #00bc12;
	color: #fff;
	margin-top: 30px;
	font-size: 18px;
	border-radius: 4px;
	padding-left: 40px;
	position: relative;

	&::after {
		content: '';
		position: absolute;
		width: 10px;
		border-radius: 5px;
		height: 60%;
		top: 50%;
		left: 1%;
		transform: translateY(-50%);
		background-color: rgba(255, 255, 128, 1);
	}
}

.taskxqtitle {
	width: 100%;
	padding: 10px 0;
	background-color: #00bc12;
	text-align: center;
	color: #fff;
	font-size: 18px;
	border-radius: 50px;
}

.taskxqtitletopcontent {
	display: flex;
	justify-content: space-between;
	margin-top: 20px;

	.taskxqtitletopright {
		width: 72%;
		background-color: #fff;
		border-radius: 10px;
		padding: 10px 20px;
	}

	.taskxqtitletopleft {
		width: 25%;
		img {
			width: 100%;
		}

		.taskxqbotmbox {
			background: #fff;
			border-radius: 10px;
			padding: 15px;
			box-sizing: border-box;
			margin-top: 20px;
			height: 200px;

			.taskxqbotmboxtitle {
				font-weight: 700;
				font-size: 20px;
				color: #000;
				padding-left: 10px;
			}
			.taskxqbotmboxusers {
				font-size: 16px;
				margin: 5px 0;
				.icons {
					color: #333;
					margin-right: 5px;
				}
				.tasktitle {
					color: #333;
					font-weight: 600;
					font-size: 16px;
				}
			}
		}
	}
}
</style>
